(function () {
  const SECTION_SELECTOR = "[data-glp1-ingredient-highlights]";

  function getTabs(section) {
    return Array.from(section.querySelectorAll("[data-ingredient-tab]"));
  }

  function getPanels(section) {
    return Array.from(section.querySelectorAll("[data-ingredient-panel]"));
  }

  function activateTab(section, index) {
    const tabs = getTabs(section);
    const panels = getPanels(section);

    tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }

  function activateTabByBlockId(section, blockId) {
    if (!blockId) return;

    const tabs = getTabs(section);
    const nextIndex = tabs.findIndex((tab) => tab.dataset.ingredientBlockId === blockId);
    if (nextIndex >= 0) activateTab(section, nextIndex);
  }

  function getTabContext(tab) {
    const section = tab.closest(SECTION_SELECTOR);
    if (!section) return null;

    const tabs = getTabs(section);
    const index = tabs.indexOf(tab);
    if (index < 0) return null;

    return { section, tabs, index };
  }

  function initSection(section) {
    if (!section) return;

    const tabs = getTabs(section);
    if (!tabs.length) return;

    if (section.dataset.ingredientTabsInitialized === "true") return;
    section.dataset.ingredientTabsInitialized = "true";

    activateTab(section, 0);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initSection(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target?.closest(SECTION_SELECTOR);
    if (!section) return;

    initSection(section);
    activateTabByBlockId(section, event.detail?.blockId);
  });
  document.addEventListener("click", (event) => {
    const tab = event.target.closest("[data-ingredient-tab]");
    if (!tab) return;

    const context = getTabContext(tab);
    if (!context) return;

    activateTab(context.section, context.index);
  });
  document.addEventListener("keydown", (event) => {
    const tab = event.target.closest("[data-ingredient-tab]");
    if (!tab) return;
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft" && event.key !== "Home" && event.key !== "End") return;

    const context = getTabContext(tab);
    if (!context) return;

    event.preventDefault();

    let nextIndex = context.index;
    if (event.key === "ArrowRight") nextIndex = (context.index + 1) % context.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (context.index - 1 + context.tabs.length) % context.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = context.tabs.length - 1;

    activateTab(context.section, nextIndex);
    context.tabs[nextIndex].focus();
  });
})();
